module.exports = __webpack_public_path__ + "static/img/logo2.0816de7.png";


//////////////////
// WEBPACK FOOTER
// ./static/styles/mailkit/img/logo2.png
// module id = HrD6
// module chunks = 1